import type { TradeSelectorVariant } from "@simplybusiness/mobius-trade-selector";
import type { QuestionComponentProps } from "../../types";
import { TradeQuestion as DefaultTradeQuestion } from "./TradeQuestion";
import { AiTradeQuestion } from "./AiTradeQuestion";

export const TradeQuestion = (props: QuestionComponentProps) => {
  const { type } = props;

  const variant: TradeSelectorVariant =
    type === "trade_search_ai" ? "ai" : "default";

  if (variant === "ai") {
    return <AiTradeQuestion {...props} />;
  } else {
    return <DefaultTradeQuestion {...props} />;
  }
};
